<template>
  <div>
    <BarChart
      v-if="loaded"
      class="chart"
      :style="styleChart"
      :chart-data="datacollection"
      :options="options"
    ></BarChart>
  </div>
</template>

<script>
import APIService from '../../APIService'
export default {
  components: {
    BarChart: () => import('./BarChart.js')
  },
  props: {
    queryId: {
      type: String,
      default: null
    },
    schema: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    xtitle: {
      type: String,
      default: null
    },
    ytitle: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    yMin: {
      type: Number,
      default: undefined
    },
    yMax: {
      type: Number,
      default: undefined
    },
    xMinTicks: {
      type: Number,
      default: 1
    },
    xMaxTicks: {
      type: Number,
      default: 10
    },
    styleChart: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loaded: false,
      backgroundColor: ['#88BF4D', '#EF8C8C'],
      allDataSet: {},
      allData: [],
      obj: [],
      count: 0,
      items: null,
      dataVal: [],
      labelsUniq: [],
      datacollection: null,
      labels: [],
      options: {
        maintainAspectRatio: false,
        legend: {
          align: 'start',
          labels: {
            usePointStyle: true,
            fontStyle: 'bold',
            padding: 30
          }
        },
        title: {
          display: true,
          text: this.title,
          fontSize: 15
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.ytitle,
                fontStyle: 'bold',
                fontSize: 15
              },
              gridLines: {
                drawTicks: true,
                borderDash: [5, 4]
              },
              ticks: {
                beginAtZero: false,
                min: this.yMin,
                max: this.yMax,
                fontSize: 12
              }
            }
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.xtitle,
                fontStyle: 'bold',
                fontSize: 15
              },
              gridLines: {
                drawTicks: true,
                display: false
              },
              ticks: {
                autoSkip: true,
                maxTicksLimit: 10,
                minTicksLimit: 1,
                fontSize: 12,
                padding: 20
              }
            }
          ]
        }
      }
    }
  },

  created() {
    APIService.getQueryData(this.queryId)
      .then((res) => {
        this.items = res.data

        this.items.forEach((element) => {
          if (element._id != undefined) {
            this.labels.push(element._id)
          }
        })
        this.labelsUniq = this.labels.filter(
          (v, i) => this.labels.indexOf(v) === i
        )

        var groupBy = this.items.reduce((result, currentValue) => {
          if (!result[currentValue.inties]) {
            result[currentValue.inties] = []
          }
          if ((currentValue._id && currentValue.count) != undefined) {
            result[currentValue.inties].push({
              x: currentValue._id,
              y: currentValue.count
            })
          }
          return result
        }, {})

        for (let key in groupBy) {
          this.allDataSet = {
            label: key,
            data: groupBy[key],
            backgroundColor: this.backgroundColor[this.count],
            borderColor: this.backgroundColor[this.count]
          }

          this.allData.push(this.allDataSet)
          this.count++
        }
        this.fillData()
        this.loaded = true
      })
      .catch((ex) => {
        console.log(ex.response)
      })
  },

  mounted() {
    this.loaded = false
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: this.labelsUniq,
        datasets: this.allData
      }
    }
  }
}
</script>
<style scoped>
.chart {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 8px;
  padding: 10px;
}
</style>
